import { Injectable } from '@angular/core';
import { CloudFunctionsApiService } from './cloud-functions-api.service';

@Injectable({
  providedIn: 'root',
})
export class ColegiosService {
  constructor(private api: CloudFunctionsApiService) {}

  getColegios() {
    return this.api.snapshotList('/schools');
  }

  getColegiosNow() {
    return this.api.getCollection('/schools');
  }

  getColegioById(uid) {
    return this.api.documentChange(`/schools/${uid}`);
  }

  getColegioByIdNow(uid) {
    return this.api.getDocument(`/schools/${uid}`);
  }

  getColegioByCursoId(uid) {
    return this.api.snapshotList(`/schools?courseId=${encodeURIComponent(uid)}`);
  }

  createdColegio(colegio) {
    return this.api.post('/schools', colegio).toPromise();
  }

  editColegio(colegio, id) {
    return this.api.patch(`/schools/${id}`, colegio).toPromise();
  }

  deleteColegio(uid) {
    return this.api.delete(`/schools/${uid}`).toPromise();
  }
}
